export default {
  common: {
    loading: 'جارٍ التحميل…',
    save: 'حفظ',
    cancel: 'إلغاء',
    create: 'إنشاء',
    delete: 'حذف',
    revoke: 'إبطال',
    update: 'تحديث',
    edit: 'تعديل',
    confirm: 'تأكيد',
    back: 'رجوع',
    search: 'بحث',
    refresh: 'تحديث',
    yes: 'نعم',
    no: 'لا',
    none: 'لا شيء',
    all: 'الكل',
    none_dash: '—',
    error: 'خطأ',
    success: 'تم',
    pending: 'قيد الانتظار',
    active: 'نشط',
    revoked: 'ملغى',
    disabled: 'معطّل',
    suspended: 'موقوف',
    copied: 'تم النسخ',
    copy_failed: 'فشل النسخ',
    saving: 'جارٍ الحفظ…',
    copy: 'نسخ',
    close: 'إغلاق',
    download: 'تنزيل',
    export_csv: 'تصدير CSV',
    sign_out: 'تسجيل الخروج',
    language: 'اللغة',
    actions: 'إجراءات',
    next: 'التالي',
    previous: 'السابق',
    page: 'صفحة',
    yes_continue: 'نعم، متابعة',
    saved: 'تم الحفظ',
    deleted: 'تم الحذف',
    failed: 'فشل',
    retry: 'إعادة المحاولة',
    enable: 'تفعيل',
    disable: 'تعطيل',
    activate: 'تفعيل',
    deactivate: 'تعطيل',
    optional: 'اختياري',
    required: 'مطلوب',
    apply: 'تطبيق',
    reset: 'إعادة تعيين',
    expand: 'توسيع',
    collapse: 'طيّ',
    show: 'إظهار',
    hide: 'إخفاء',
    created: 'تاريخ الإنشاء',
    updated: 'تاريخ التحديث',
    not_set: 'غير محدد',
    not_available: 'غير متاح',
    open_in_new: 'فتح في تبويب جديد',
  },
  nav: {
    dashboard: 'لوحة المعلومات',
    payments: 'المدفوعات',
    webhooks: 'الـ Webhooks',
    settlements: 'التسويات',
    merchants: 'التجار',
    gateways: 'البوابات',
    audit: 'سجل التدقيق',
    users: 'المستخدمون',
    security: 'الأمان',
    help_group: 'المساعدة',
    demo_requests: 'طلبات التجربة',
    user_guide: 'دليل المستخدم',
    api_reference: 'مرجع الـ API',
    psp_integrations: 'دليل تكامل مزوّدي الدفع',
    webhook_signing: 'توقيع الـ Webhook',
    event_catalog: 'كتالوج الأحداث',
  },
  auth: {
    sign_in_title: 'تسجيل الدخول إلى PayHub',
    sign_in_subtitle: 'وحدة تحكم المشغّل',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    sign_in: 'تسجيل الدخول',
    mfa_title: 'أدخل رمز التطبيق المُصادِق',
    mfa_code: 'رمز لمرة واحدة',
    mfa_verify: 'تحقّق',
    mfa_help: 'افتح تطبيق المصادقة وأدخل الرمز المكوّن من 6 أرقام.',
    invalid_credentials: 'اسم المستخدم أو كلمة المرور غير صحيحة',
    invalid_code: 'رمز غير صحيح',
    demo_banner_title: 'بيئة تجريبية',
    demo_use_credentials: 'استخدام بيانات الاعتماد التجريبية',
    demo_request_title: 'جرّب نسخة PayHub التجريبية',
    demo_request_subtitle:
      'الوصول إلى البيئة التجريبية بطلب مسبق. أخبرنا عن نفسك وسيُرسل لك المشغّل رابط دخول لمرة واحدة.',
    demo_request_cta: 'طلب وصول',
    demo_have_token_cta: 'لديّ رمز',
  },
  dashboard: {
    title: 'لوحة المعلومات',
    subtitle: 'آخر {{hours}} ساعة',
    inflight: 'مدفوعات قيد التنفيذ',
    payments_by_status: 'المدفوعات حسب الحالة',
    payments_by_psp: 'المدفوعات حسب البوابة',
    deliveries_by_status: 'تسليمات الـ Webhook',
    no_data: 'لا توجد بيانات في هذه الفترة بعد.',
    initiated: 'بدأت',
    succeeded: 'نجحت',
    failed: 'فشلت',
    in_flight: 'قيد التنفيذ',
    count: 'العدد',
  },
  payments: {
    title: 'المدفوعات',
    subtitle: 'جميع عمليات الدفع عبر التجار والبوابات.',
    filter_psp: 'البوابة',
    filter_status: 'الحالة',
    filter_merchant: 'التاجر',
    no_results: 'لا توجد مدفوعات تطابق المرشحات الحالية.',
    cols: {
      created: 'تاريخ الإنشاء',
      psp: 'البوابة',
      order_ref: 'رقم الطلب',
      psp_ref: 'مرجع البوابة',
      amount: 'المبلغ',
      currency: 'العملة',
      status: 'الحالة',
    },
    detail: {
      title: 'الدفعة {{id}}',
      back_to_list: 'العودة إلى المدفوعات',
      timeline: 'الخط الزمني',
      psp_payload: 'حمولة البوابة',
      metadata: 'البيانات الوصفية',
      events: 'الأحداث',
      not_found: 'الدفعة غير موجودة.',
      no_events: 'لم تُسجَّل أحداث بعد.',
      event: 'الحدث',
      source: 'المصدر',
      from_status: 'من حالة',
      to_status: 'إلى حالة',
      copy_id: 'نسخ المعرّف',
      checkout_link: 'رابط صفحة الدفع المستضافة',
      issue_link: 'إصدار رابط دفع',
      link_issued: 'تم إصدار الرابط — انسخه الآن (تنتهي صلاحيته خلال {{seconds}} ث)',
      link_failed: 'فشل في إصدار الرابط',
      record_refund: 'تسجيل استرداد',
      refund_dialog_title: 'تسجيل عملية استرداد',
      refund_dialog_desc:
        'تتم تسوية الاسترداد لدى البوابة في النظام الخلفي. استخدم هذا النموذج لتسجيل أن الاسترداد قد تم خارجياً حتى تتطابق المصالحة ويتلقى التاجر Webhook.',
      refund_amount: 'المبلغ (بالوحدات الصغرى)',
      refund_reason: 'السبب (اختياري)',
      refund_psp_ref: 'مرجع البوابة الخلفي (اختياري)',
      refund_full: 'استرداد كامل (تنتقل الدفعة إلى حالة مُسترد)',
      refund_partial: 'استرداد جزئي (يُسجَّل الحدث؛ تبقى الدفعة بحالة ناجحة)',
      refund_success: 'تم تسجيل الاسترداد؛ تمت جدولة Webhook.',
      refund_failed: 'فشل تسجيل الاسترداد',
      refund_only_succeeded: 'يمكن تسجيل الاسترداد فقط على الدفعات الناجحة.',
      repoll: 'إعادة الاستعلام من المزوّد',
      repoll_busy: 'جارٍ الاستعلام…',
      repoll_no_change: 'لا يزال المزوّد بدون إجابة قاطعة — الدفعة دون تغيير.',
      repoll_transitioned: 'أكّد المزوّد الحالة: {{status}}.',
      repoll_failed: 'فشلت إعادة الاستعلام',
      force_resolve: 'حسم يدوي',
      force_resolve_title: 'حسم الدفعة يدويًا',
      force_resolve_desc:
        'تحويل هذه الدفعة إلى حالة نهائية يدويًا. استخدم هذا الخيار فقط عندما يعجز المزوّد عن إعطاء جواب قاطع (تنبيه مفقود، تخلّي العميل). يُسجَّل السبب في سجل المراجعة.',
      force_resolve_target_label: 'الحالة الجديدة',
      force_resolve_target_succeeded: 'ناجحة — تأكدنا من تسوية المبلغ',
      force_resolve_target_failed: 'فاشلة — تأكدنا من عدم تسوية المبلغ',
      force_resolve_target_expired: 'منتهية — تخلّى العميل / تجاوز الوقت',
      force_resolve_reason_label: 'السبب (مطلوب، يُحفظ في سجل المراجعة)',
      force_resolve_reason_placeholder:
        'مثلاً: أكّد دعم موبي‌كاش أن إذن المحفظة لم يصلنا — تذكرة #1234',
      force_resolve_reason_required: 'السبب مطلوب (٤ أحرف على الأقل).',
      force_resolve_confirm: 'حسم يدوي',
      force_resolve_success: 'تم حسم الدفعة؛ كُتب صف في سجل المراجعة.',
      force_resolve_failed: 'فشل حسم الدفعة يدويًا',
    },
  },
  merchants: {
    title: 'التجار',
    subtitle: 'الكيانات الفرعية ضمن هذا التثبيت.',
    create: 'تاجر جديد',
    edit: 'تعديل التاجر',
    delete: 'حذف التاجر',
    code: 'الرمز',
    name: 'الاسم',
    status: 'الحالة',
    payments_count: 'المدفوعات',
    create_description: 'الرمز هو المعرّف الثابت في سجلات الـ API وروابط الـ Webhook. اختر بعناية.',
    edit_description: 'حدّث رمز التاجر أو اسمه أو حالته.',
    delete_title: 'حذف التاجر',
    delete_confirm: 'هل تريد حذف هذا التاجر؟ سيُحذف معه كل ما يخصّه: مفاتيح الـ API، البوابات، الـ Webhooks، التسويات.',
    delete_blocked: 'لا يمكن الحذف: التاجر لديه {{count}} مدفوعة. أوقفه بدلاً من ذلك.',
    delete_blocked_short: 'يوجد {{count}} مدفوعة',
    suspend: 'إيقاف',
    unsuspend: 'استئناف',
    none: 'لا يوجد تجار بعد.',
    api_keys_tab: 'مفاتيح الـ API',
    gateways_tab: 'البوابات',
    webhooks_tab: 'الـ Webhooks',
    detail_back: 'العودة إلى التجار',
    code_invalid: 'حروف صغيرة وأرقام و _ و - فقط',
    pick_merchant: 'اختر تاجراً لإدارة بواباته.',
  },
  api_keys: {
    title: 'مفاتيح الـ API',
    description: 'تمنح المفاتيح الوصول إلى /v1/* لهذا التاجر. كل مفتاح يحمل قائمة عناوين IP اختيارية وفئة لحدّ معدّل الطلبات.',
    new: 'مفتاح جديد',
    cols: {
      key_id: 'معرّف المفتاح',
      scopes: 'النطاقات',
      tier: 'الفئة',
      allowlist: 'قائمة عناوين IP المسموح بها',
      status: 'الحالة',
      last_used: 'آخر استخدام',
    },
    none: 'لا توجد مفاتيح بعد.',
    revoke_confirm: 'إبطال هذا المفتاح؟ سيبدأ العملاء الذين يستخدمونه بالفشل فوراً.',
    revoked_toast: 'تم إبطال المفتاح',
    create_failed: 'فشل الإنشاء',
    update_failed: 'فشل التحديث',
    revoke_failed: 'فشل الإبطال',
    edit_title: 'تعديل مفتاح الـ API',
    edit_description: 'حدّث قائمة الـ IP أو فئة الحد. لن تُعاد إصدار السرّ.',
    create_title: 'مفتاح API جديد',
    create_description: 'تُمنح النطاقات لكل من يستخدم هذا المفتاح. تُفرض قائمة الـ IP بعد التحقق من السرّ؛ اتركها فارغة لإلغاء التقييد.',
    scopes_label: 'النطاقات (واحد في كل سطر)',
    allowlist_label: 'قائمة CIDR (واحدة في كل سطر، فارغة = أي IP)',
    tier_label: 'فئة الحد',
    invalid_cidr: 'إدخالات CIDR/IP غير صالحة: {{entries}}',
    secret_revealed_title: 'تم إنشاء المفتاح',
    secret_revealed_description: 'انسخ هذا السرّ الآن — لن يُعرض مرة أخرى. نخزّن تجزئة argon2id فقط.',
    secret_revealed_ack: 'لقد حفظته',
    any_ip: '— أي IP',
    updated_toast: 'تم تحديث المفتاح',
    tiers: {
      free: 'مجاني',
      standard: 'قياسي',
      premium: 'متميز',
      enterprise: 'مؤسسي',
    },
  },
  gateways_panel: {
    title: 'البوابات',
    description: 'إعدادات بيانات الاعتماد لكل بوابة دفع. الأسرار مشفّرة بنظام التغليف (AES-GCM + KEK).',
    psp_label: 'البوابة',
    env_label: 'البيئة',
    base_url_label: 'عنوان URL الأساسي (تجاوز)',
    proxy_label: 'عنوان البروكسي',
    ca_bundle_label: 'حزمة CA (PEM)',
    payload_label: 'بيانات الاعتماد',
    active_label: 'نشط',
    inactive_label: 'غير نشط',
    test: 'اختبار',
    save: 'حفظ',
    test_passed: 'نجح الاختبار',
    test_failed: 'فشل الاختبار',
    saved_toast: 'تم حفظ البوابة',
    deactivated_toast: 'تم تعطيل البوابة',
    deactivate_confirm: 'هل تريد تعطيل هذه البوابة؟',
    none: 'لم يتم تكوين بوابات بعد.',
    secret_placeholder: '••••••• (مضبوط؛ لا يمكن إظهاره)',
    add_for: 'إضافة بيانات اعتماد لـ {{psp}}',
    no_schema: 'لا يوجد مخطط بيانات اعتماد لـ {{psp}}',
  },
  webhook_endpoints: {
    title: 'نقاط الـ Webhook',
    description: 'العناوين التي تستقبل الأحداث الموقّعة لهذا التاجر.',
    new: 'نقطة جديدة',
    cols: {
      url: 'العنوان',
      events: 'الأحداث',
      active: 'نشط',
      created: 'تاريخ الإنشاء',
    },
    url_label: 'العنوان',
    secret_label: 'السرّ (16 حرفاً على الأقل)',
    events_label: 'الأحداث (مفصولة بفواصل، * = الكل)',
    none: 'لا توجد نقاط بعد.',
    create_title: 'نقطة Webhook جديدة',
    deactivate_confirm: 'هل تريد تعطيل هذه النقطة؟',
    deactivated_toast: 'تم تعطيل النقطة',
    saved_toast: 'تم إنشاء النقطة',
  },
  webhook_deliveries: {
    title: 'تسليمات الـ Webhook',
    subtitle: 'التسليمات الصادرة؛ يمكن إعادة التسليمات الفاشلة أو وضعها كمحلولة.',
    cols: {
      next_attempt: 'المحاولة التالية',
      attempt: 'المحاولة',
      status: 'الحالة',
      response: 'الاستجابة',
      created: 'تاريخ الإنشاء',
    },
    filter_status: 'الحالة',
    none: 'لا توجد تسليمات تطابق.',
    replay: 'إعادة',
    resolve: 'تعليم كمحلول',
    replayed_toast: 'تمت جدولة الإعادة',
    resolved_toast: 'تم وضعه كمحلول',
    replay_failed: 'فشلت الإعادة',
    resolve_failed: 'فشل التعليم',
  },
  settlements: {
    title: 'التسويات',
    subtitle: 'ملفات تسوية يومية تُطابَق مع المدفوعات.',
    upload: 'رفع تسوية',
    pull: 'سحب من البوابة',
    cols: {
      uploaded: 'تاريخ الرفع',
      psp: 'البوابة',
      file: 'الملف',
      rows: 'الصفوف',
      matched: 'مطابقة',
      mismatch: 'عدم تطابق',
      missing_in_hub: 'مفقود في النظام',
      missing_in_psp: 'مفقود لدى البوابة',
    },
    upload_dialog: {
      title: 'رفع ملف تسوية',
      description: 'ملف CSV من بوابة الدفع.',
      merchant_label: 'التاجر',
      psp_label: 'البوابة',
      period_from: 'من',
      period_to: 'إلى',
      file_label: 'ملف CSV',
      submit: 'رفع',
      uploading: 'جارٍ الرفع…',
      uploaded_toast: 'تم استيعاب {{rows}} صفاً ({{matched}} مطابق)',
      upload_failed: 'فشل الرفع',
    },
    pull_dialog: {
      title: 'سحب تسوية من البوابة',
      description: 'يُطلق عملية سحب لتقرير التسوية من البوابة لنطاق محدّد.',
      submit: 'سحب',
      pulled_toast: 'تمت جدولة السحب',
      pull_failed: 'فشل السحب',
      no_supported: 'لا توجد بوابة تدعم السحب البرمجي حالياً.',
    },
    detail: {
      back: 'رجوع',
      rows: 'الصفوف',
      filter: 'تصفية',
      status: 'الحالة',
      order_ref: 'رقم الطلب',
      psp_ref: 'مرجع البوابة',
      amount: 'المبلغ',
      psp_status: 'حالة البوابة',
      diff: 'الفرق',
      no_rows: 'لا توجد صفوف في هذا العرض.',
      not_found: 'ملف التسوية غير موجود.',
    },
    none: 'لا توجد تسويات بعد.',
  },
  audit: {
    title: 'سجل التدقيق',
    subtitle: 'يُسجَّل كل تغيير إداري مع لقطات قبل وبعد.',
    filter_action: 'بادئة الإجراء',
    filter_target_type: 'نوع الهدف',
    filter_target_id: 'معرّف الهدف',
    cols: {
      time: 'الوقت',
      actor: 'الفاعل',
      action: 'الإجراء',
      target: 'الهدف',
    },
    no_results: 'لا توجد سجلات تطابق.',
    before: 'قبل',
    after: 'بعد',
    expand: 'توسيع',
    actor_admin: 'مشرف',
    actor_system: 'النظام',
    actor_merchant: 'تاجر',
  },
  security: {
    title: 'الأمان',
    subtitle: 'إعدادات الأمان على مستوى الحساب.',
    mfa_title: 'المصادقة متعددة العوامل',
    mfa_enabled: 'المصادقة متعددة العوامل مُفعّلة على حسابك.',
    mfa_disabled: 'المصادقة غير مُفعّلة. فعّلها أدناه.',
    enrol: 'إعداد MFA',
    confirm: 'تأكيد الرمز',
    disable: 'تعطيل MFA',
    enrol_step: 'الخطوة {{n}} من 2',
    scan_qr: 'امسح هذا الرمز بتطبيق المصادقة، ثم أدخل الرمز المكوّن من 6 أرقام.',
    secret_label: 'السرّ (إدخال يدوي)',
    code: 'رمز من 6 أرقام',
    password_to_disable: 'أعد إدخال كلمة المرور لتعطيل MFA',
    enabled_toast: 'تم تفعيل MFA',
    disabled_toast: 'تم تعطيل MFA',
    enrol_failed: 'فشل بدء التسجيل',
    confirm_failed: 'لم يتم التحقق من الرمز',
    disable_failed: 'فشل تعطيل MFA',
    issuer_label: 'الجهة المُصدِرة',
    account_label: 'الحساب',
  },
  webhook_verification: {
    title: 'التحقق من توقيع الـ Webhook',
    description: 'يوقّع PayHub كل Webhook صادر حتى تتمكّن من إثبات مصدره وعدم العبث به.',
    algorithm_title: 'الخوارزمية',
    snippets_title: 'تطبيقات مرجعية',
  },
  event_catalog: {
    title: 'كتالوج الأحداث',
    subtitle:
      'جميع الأحداث التي يُطلقها النظام، وتغيّرات الحالة المصاحبة لها، وما إذا كانت تُرسل Webhook.',
    status_change: 'تغيّر الحالة',
    source: 'المصدر',
    always_emits: 'يُرسَل دائماً',
    on_match: 'حسب الاشتراك',
    never_emits: 'داخلي فقط',
  },
  api_docs: {
    title: 'مرجع الـ API',
    subtitle: 'مواصفات OpenAPI الحيّة لـ /v1 — مولّدة من الخادم العامل.',
    open_swagger: 'فتح Swagger UI',
    download_json: 'تنزيل openapi.json',
    search_placeholder: 'ابحث بالمسار أو الملخّص أو معرّف العملية…',
    no_match: 'لا توجد عمليات مطابقة.',
    parameters: 'المعاملات',
    request_body: 'حمولة الطلب',
    responses: 'الاستجابات',
    description_label: 'الوصف',
    of_count: '{{shown}} من {{total}}',
    no_description: 'لا يوجد وصف.',
  },
  merchant: {
    nav: {
      gateways: 'البوابات',
      integrations: 'دليل التكامل',
      users: 'المستخدمون',
      org: 'المؤسسة',
      profile: 'الملف الشخصي',
    },
  },
  demo: {
    request: {
      title: 'طلب وصول للنسخة التجريبية',
      subtitle:
        'املأ بياناتك. سيراجع المشغّل طلبك ويُرسل إليك بريداً يحتوي رابط دخول لمرة واحدة محدوداً بمدّة.',
      name_label: 'الاسم الكامل',
      email_label: 'البريد الإلكتروني',
      company_label: 'الشركة (اختياري)',
      phone_label: 'الهاتف (اختياري)',
      use_case_label: 'ما الذي تودّ تجربته؟ (اختياري)',
      use_case_placeholder:
        'صف باختصار ما تنوي اختباره — أيّ مزوّد دفع، أيّ تدفّق، وأيّ شيء يجب تهيئته مسبقاً لك.',
      submit: 'إرسال الطلب',
      error: 'تعذّر إرسال الطلب. حاول مرة أخرى.',
      thanks_title: 'تم استلام الطلب',
      thanks_subtitle: 'سنتواصل معك قريباً',
      thanks_body:
        'تم استلام طلبك وتنبيه المشغّل. عند الموافقة ستصلك رسالة بريدية تحتوي رابط دخول لمرة واحدة.',
      have_token_cta: 'لديّ رمز بالفعل',
    },
    login: {
      title: 'تسجيل الدخول برمز التجربة',
      subtitle: 'الصق الرمز من رسالة الموافقة، أو افتح الرابط مباشرة.',
      token_label: 'رمز الدخول',
      token_help: 'استخدام واحد فقط؛ تنتهي صلاحيته وفق ما يحدّده المشغّل.',
      submit: 'تسجيل الدخول',
      error: 'الرمز غير صالح أو منتهي.',
      no_token_cta: 'طلب وصول',
    },
  },
  demo_admin: {
    eyebrow: 'طلبات وصول التجربة',
    title: 'إدارة طلبات التجربة',
    subtitle:
      'راجع الطلبات المعلّقة، اقبلها بمدّة صلاحية لتوليد رمز لمرة واحدة (يُرسل بريدياً تلقائياً)، أو ارفضها مع سبب.',
    tab_pending: 'معلّق',
    tab_approved: 'مقبول',
    tab_rejected: 'مرفوض',
    empty: 'لا توجد طلبات في هذه الحالة.',
    field_company: 'الشركة',
    field_phone: 'الهاتف',
    field_use_case: 'حالة الاستخدام',
    field_rejection_reason: 'سبب الرفض',
    status_pending: 'معلّق',
    status_approved: 'مقبول',
    status_rejected: 'مرفوض',
    status_used: 'تم استخدام الرمز',
    status_revoked: 'ملغى',
    status_expired: 'منتهي',
    approve: 'قبول',
    reject: 'رفض',
    revoke: 'إلغاء الرمز',
    approve_title: 'قبول {{name}}',
    approve_subtitle:
      'إصدار رمز دخول لمرة واحدة. يُرسل الرمز فوراً بالبريد، ويظهر هنا مرة واحدة كنسخة احتياطية إن تعذّر التسليم.',
    approve_confirm: 'إصدار الرمز',
    approve_toast: 'تم القبول — صدر الرمز',
    ttl_label: 'مدّة الصلاحية (ساعات)',
    ttl_help: '1–168. الافتراضي 24 ساعة.',
    issued_body:
      'تم إصدار الرمز وإرساله بالبريد. النص الصريح يظهر مرة واحدة فقط — انسخه الآن إن احتجت بديلاً.',
    issued_link_label: 'رابط دخول لمرة واحدة',
    issued_token_label: 'الرمز',
    issued_expires: 'ينتهي {{when}}',
    reject_title: 'رفض {{name}}',
    reject_subtitle: 'سيُبلّغ مقدّم الطلب بالبريد الإلكتروني.',
    reason_label: 'السبب (اختياري)',
    reason_placeholder:
      'اشرح باختصار سبب الرفض. يظهر لمقدّم الطلب.',
    reason_help: 'يُحفظ على الطلب في سجل التدقيق. اتركه فارغاً لرفض عام.',
    reject_confirm: 'رفض الطلب',
    reject_toast: 'تم الرفض',
    revoke_toast: 'تم إلغاء الرمز',
    token_issued: 'صدر',
    token_expires: 'ينتهي',
    token_used: 'مستخدم',
    token_revoked: 'ملغى',
  },
  psp_guide: {
    eyebrow: 'دليل تكامل مزوّدي الدفع',
    title: 'تكامل سداد ومعاملات وموبيكاش وتي‑لينك وأدفع‑لي',
    subtitle:
      'وصفات تطبيق خطوة بخطوة لكل مزوّد دفع — ماذا ترسل، وماذا تتوقّع، وماذا تعالج على خادمك. القسم المشترك يغطّي المصادقة والـ Idempotency وتوقيع الـ Webhook مرة واحدة؛ تبويبات المزوّدين تُغطّي ما يختلف.',
  },
  guide: {
    title: 'دليل المشغّل',
    subtitle: 'جولة سريعة في إدارة PayHub وكيفية ترابط أجزائها.',
    quickstart: 'بداية سريعة',
    quickstart_steps: 'سجّل تاجراً → اضبط بيانات اعتماد بوابات الدفع → راقب تدفق المدفوعات على لوحة المعلومات.',
    section_auth: 'المصادقة',
    section_merchants: 'التجار ومفاتيح الـ API',
    section_gateways: 'البوابات (بيانات اعتماد البوابات)',
    section_payments: 'المدفوعات',
    section_webhooks: 'الـ Webhooks',
    section_settlements: 'التسويات والمطابقة',
    section_audit: 'سجل التدقيق',
    section_security: 'الأمان والامتثال',
    open_section: 'فتح',
  },
  empty: {
    nothing_to_show: 'لا يوجد ما يُعرض',
    something_went_wrong: 'حدث خطأ ما',
  },
};
